import React from 'react';
import ReportesOrdenesCompra from '../components/ReportesOrdenesCompra';

const ReportesCompras: React.FC = () => {
  return <ReportesOrdenesCompra />;
};

export default ReportesCompras;
